import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";

const PortalAccessFooter = ({ children }: PropsWithChildren) => (
  <Stack
    direction="row"
    useFlexGap
    sx={{
      alignItems: "center",
      flexWrap: "wrap",
      columnGap: 2,
      rowGap: 0.5,
      px: 2.5,
      py: 1.25,
      bgcolor: "background.grey",
    }}
  >
    {children}
  </Stack>
);

export default PortalAccessFooter;
